/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Fragment, h } from 'preact';
import styled from 'styled-components';
import { useEffect, useRef } from 'preact/hooks';
import { Tabs } from 'antd-mobile';
import ListItem from '../../extension/component/ListItem';
import Item from '../../extension/component/Item';
import TbItem from '../../extension/component/TbItem';
import { throttle } from 'lodash';
const List: any = ({
  searchCategoryList,
  list,
  handelCategoryId,
  cateList,
  liveFlatFlag,
  scene,
  handleMoreData,
  setItem,
}: any) => {
  useEffect(() => {
    const handleScroll = () => {
      if (liveFlatFlag == false) {
        let lastCategory_id = '';
        cateList.map((item: any) => {
          const domObj: any = document.getElementById(
            `title-${item.category_id}`,
          );
          const offsetTop = domObj.offsetTop;
          if (window.scrollY + 240 > offsetTop) {
            lastCategory_id = item.category_id;
          }
          if (
            offsetTop - window.scrollY > 0 &&
            offsetTop - window.scrollY <= 240
          ) {
            lastCategory_id = item.category_id;
          }
        });
        if (lastCategory_id) {
          handelCategoryId(lastCategory_id);
        }
      } else if (scene == 'live') {
        const offset = document.documentElement.clientHeight;
        const height = document.documentElement.scrollHeight;
        if (height - window.scrollY - offset < 10) {
          handleMoreData();
        }
      }
    };
    const acton = throttle(handleScroll, 20);
    window.addEventListener('scroll', acton);
    return () => {
      window.removeEventListener('scroll', acton);
    };
  }, []);
  return (
    <Container>
      <ListWrap className="live-list">
        {list.map((item: any) => {
          return (
            <TbItem
              setItem={setItem}
              item={item}
              key={item.item_id}
              scene={scene}
            />
          );
        })}
      </ListWrap>
    </Container>
  );
};

export default List;

const Container = styled.div`
  width: 702px;
`;
const ListWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
`;
const HisList = styled.div`
  margin-top: 12px;
  width: 100%;
`;
